import React, { useState, useEffect } from 'react'
import {
  Panel,
  Button,
  Row,
  Col,
  ControlLabel,
  SelectPicker,
  DatePicker,
  Message,
  Uploader,
  Icon,
  ButtonGroup,
  IconButton,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import InputForm from '../../components/forms/input/InputForm'
import ConfirmWidget from '../confirm/ConfirmWidget'
import {
  approveSubprojectCloseOfProject,
  updateSubprojectCloseOfProject,
} from '../../redux/actions/closeOfProject'
import { useParams, useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import { isImageOrPdf, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import AttachFilesForm from '../attachfiles/AttachFilesForm'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../constants/date'
import { getValueFromOptions } from '../../utils/dataUtil'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import EditButton from '../../components/buttons/editButton/EditButton'
import IncomeRecordFileTable from '../incomeRecordWidget/IncomeRecordFileTable'
import { downloadSubprojectFile } from '../../redux/actions/subProject'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import notification from '../../utils/notification'
import { cloneDeep } from 'lodash-es'

export default function CloseSubProjectWidget({ schema: _schema, ...props }) {
  const { showCommandButton, isEditAll, isApprove, disabledForm, attachments = [] } = props
  const [isEdit, setIsEdit] = useState(false)
  const [isError, setIsError] = useState(false)
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [request, setRequest] = useState()
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [fileTypeError, setFileTypeError] = useState(false)
  const [fileList, setFileList] = useState([])
  const [deleteFilePath, setDeleteFilePath] = useState([])
  const [attachmentsList, setAttachmentsList] = useState(attachments)

  const [approveRequest, setApproveRequest] = useState()
  const [isShowConfirmApprove, setIsShowConfirmApprove] = useState(false)

  const defaultSupportType = '.jpg, .jpeg, .png, .pdf'

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()

  useEffect(() => {
    setIsEdit(isEditAll)
  }, [isEditAll])

  const onSubmit = (data) => {
    console.log('onSubmit data', data)
    const file = data.attachments
    var formData = new FormData()

    file?.forEach((element) => {
      formData.append('Attachments', element.blobFile)
    })

    console.log('deleteFilePath',deleteFilePath)
    if(deleteFilePath.length > 0){
      deleteFilePath?.forEach((element) => {
        formData.append('DeleteFilePath', element)
      })
    }else{
      formData.append('DeleteFilePath', "")
    }
    

    // formData.append('projectVersionId', projectId)
    formData.append('WorkSummary', data.workSummary)
    formData.append(
      'ClosureDate',
      typeof data.closureDate == 'string' ? data.closureDate : data.closureDate.toISOString()
    )
    formData.append('ClosureType', data.closureType)

    setRequest(formData)
    // console.log('request', request)
    setIsShowConfirm(true)
  }

  const handleCallService = async () => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const response = await updateSubprojectCloseOfProject(projectId, request)

      if (response.success) {
        //success jump to new page
        setIsError(false)
        setIsShowConfirm(false)
        doneLoading()
        setIsLoading(false)
        // return history.push(`${pathname.subProject.overviewSubProject}/${projectId}`)
        return history.push(`${pathname.subProject.overviewSubProject}`)
      }
    } catch (e) {
      if (e?.response?.data) {
        setIsError(e.response.data.errors?.message)
      } else {
        setIsError('ไม่สำเร็จ')
      }
    }
    setIsShowConfirm(false)
    doneLoading()
    setIsLoading(false)
  }

  const handleCallServiceApprove = async () => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const response = await approveSubprojectCloseOfProject(projectId, approveRequest)

      if (response.success) {
        //success jump to new page
        setIsError(false)
        setIsShowConfirmApprove(false)
        doneLoading()
        setIsLoading(false)
        // return history.push(`${pathname.subProject.overviewSubProject}/${projectId}`)
        return history.push(`${pathname.subProject.overviewSubProject}`)
      }
    } catch (e) {
      if (e?.response?.data) {
        setIsError(e.response.data.errors?.message)
      } else {
        setIsError('ไม่สำเร็จ')
      }
    }
    setIsShowConfirm(false)
    doneLoading()
    setIsLoading(false)
  }

  const handleOnApprove = (approveType, buttonText) => {
    var request = {
      approveType: approveType,
      buttonText: buttonText,
      projectVersionId: projectId,
    }
    setApproveRequest(request)
    setIsShowConfirmApprove(true)
  }

  const onConfirm = () => {
    handleCallService()
    setIsShowConfirm(false)
  }

  const onCancle = () => {
    setRequest()
    setIsShowConfirm(false)
  }

  const onAddFile = (file) => {
    // let list = cloneDeep(fileList)
    // list.push(file)
    setFileList(file)
    setValue(formSchema.attachments.name, file)
  }

  const onDownload = async (fileObj) => {
    startLoading()
    try {
      var file = await downloadSubprojectFile(fileObj.path)
      var fileName = fileObj.name

      downloadFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    try {
      var file = await downloadSubprojectFile(fileObj.path)
      var fileName = fileObj.name

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'แสดง ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onDelete = (item) => {
    
    var paths = cloneDeep(deleteFilePath)
    var _attachmentsList = cloneDeep(attachmentsList)
    console.log('item', item)
    paths.push(item.path)
    console.log('paths', paths)

    var index = _attachmentsList.findIndex(i => i.id == item.id)
    console.log('index', index)
    _attachmentsList.splice(index, 1)
    setAttachmentsList(_attachmentsList)
    setDeleteFilePath(paths)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      eventKey={2}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      <Row>
        {!disabledForm ? (
          <>
            <Col xs={24} sm={24} md={24} lg={24}>
              <ErrorMessage error={errors[formSchema.closureType.name]} />
              <ControlLabel>
                {requiredFiled(formSchema.closureType.validators, formSchema.closureType.label)}
              </ControlLabel>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24}>
              <Controller
                key={formSchema.closureType.name}
                name={formSchema.closureType.name}
                control={control}
                rules={isValidators(formSchema.closureType.validators)}
                defaultValue={formSchema.closureType.value}
                render={(props) => {
                  return (
                    <SelectPicker
                      data={formSchema.closureType.options}
                      style={{ width: '100%' }}
                      searchable={false}
                      placeholder={formSchema.closureType.hint}
                      value={props.value}
                      onChange={(value) => {
                        props.onChange(value)
                        // setValue(schema.closureType.name, e)
                        clearErrors(formSchema.closureType.name)
                      }}
                    />
                  )
                }}
              />
            </Col>
          </>
        ) : (
          <>
            <p>{formSchema.closureType.label}</p>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;
              {getValueFromOptions(
                formSchema?.closureType?.options,
                formSchema?.closureType?.value
              )}
            </p>
            <br />
          </>
        )}
      </Row>

      <Row>
        {!disabledForm ? (
          <InputForm
            schema={formSchema.workSummary}
            rows={3}
            componentClass="textarea"
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
        ) : (
          <>
            <p>{formSchema.workSummary.label}</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;{formSchema.workSummary.value}</p>
            <br />
          </>
        )}
      </Row>

      <Row style={{ marginTop: 10 }}>
        {!disabledForm ? (
          <>
            <ErrorMessage error={errors[formSchema.closureDate.name]} />
            <ControlLabel>
              {requiredFiled(formSchema.closureDate.validators, formSchema.closureDate.label)}
            </ControlLabel>
            <Controller
              key={formSchema.closureDate.name}
              name={formSchema.closureDate.name}
              control={control}
              rules={isValidators(formSchema.closureDate.validators)}
              defaultValue={formSchema.closureDate.value}
              render={(props) => {
                return (
                  <DatePicker
                    format={DATE_PICKER_FORMAT}
                    locale={LOCAL_DAY_TH}
                    block
                    placement="bottomStart"
                    disabled={formSchema.closureDate.disabled}
                    // disabledDate={(date) =>
                    //   moment(getValues(schema.closureDate.name)).isBefore(date, new Date())
                    // }
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                      // let date
                      // value && (date = value.toLocaleDateString('en-ZA'))
                      // setStartDate(value)
                      // setValue(schema.costTime.startDate.name, date)
                      clearErrors(formSchema.closureDate.name)
                    }}
                    onClean={() => {
                      setValue(formSchema.closureDate.name)
                    }}
                  />
                )
              }}
            />
          </>
        ) : (
          <>
            <p>{formSchema.closureDate.label}</p>
            <p>&nbsp;&nbsp;&nbsp;&nbsp;{formSchema.closureDate.value}</p>
            <br />
          </>
        )}
      </Row>

      <Row style={{ marginTop: 10 }}>
        {!disabledForm ? (
          <>
            <ErrorMessage error={errors[formSchema.attachments.name]} />
            <Controller
              key={formSchema.attachments.name}
              name={formSchema.attachments.name}
              control={control}
              //rules={isValidators(formSchema.attachments.validators)}
              defaultValue={fileList}
            />
            <ControlLabel>{formSchema.attachments.label}</ControlLabel>

            {/* {fileTypeError && (
              <Message
                style={{ marginTop: 10, marginBottom: 10 }}
                closable
                onClose={() => {
                  setFileTypeError(false)
                }}
                showIcon
                type="error"
                description="อัพโหลดไฟล์เป็นรูปภาพหรือ PDF เท่านั้น *** ชนิดที่รองรับ png , jpeg , jpg , pdf ***"
              />
            )} */}
            <Message
              showIcon
              type="info"
              description={`ชนิดที่รองรับ : ${formSchema.attachments.fileType || defaultSupportType} ${
                formSchema.attachments.fileSize && formSchema.attachments.fileSize > 0
                  ? `, ขนาดไฟล์ไม่เกิน ${formSchema.attachments.fileSize} MB`
                  : ''
              }`}
            />
            <Uploader
              accept={formSchema.attachments.fileType || defaultSupportType}
              autoUpload={false}
              fileList={props.value}
              listType="picture-text"
              onChange={(files) => {
                let file = files[files.length - 1]

                if (formSchema.attachments.fileSize && formSchema.attachments.fileSize > 0) {
                  let isSupportSize = true
                  isSupportSize = file?.blobFile.size <= formSchema.attachments.fileSize * 1024 * 1024
                  if(!isSupportSize){
                    notification.open('error', {
                      title: `ขนาดไฟล์เกิน ${formSchema.attachments.fileSize} MB `,
                      duration: 5000,
                    })

                    files.splice(files.length - 1, 1)
                    onAddFile(fileList)
                    return
                  }
                }
                
                if (!file || isImageOrPdf(file.blobFile.type)) {
                  onAddFile(files)
                  //setFileTypeError(false)
                } else {
                  files.splice(files.length - 1, 1)
                  onAddFile(fileList)
                  notification.open('error', {
                    title: `ชนิดที่รองรับ ${formSchema.attachments.fileType || defaultSupportType}`,
                    duration: 5000,
                  })
                  //setFileTypeError(true)
                }
              }}
              draggable
            >
              <div style={{ lineHeight: '100px' }}>
                <Icon size="4x" icon="upload2" />
                <small
                  style={{
                    marginTop: '-70px',
                    display: 'block',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                  }}
                >
                  คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                </small>
              </div>
            </Uploader>

            {attachmentsList.length > 0 &&
              attachmentsList.map((item, index) => {
                return (
                  <>
                    <Row
                      style={{
                        borderStyle: 'none none groove none',
                        marginTop: 10,
                        borderColor: '#53535321',
                      }}
                      key={index}
                    >
                      <Col lg={20} md={14} sm={24} xs={24} style={{ padding: 10 }}>
                        {`${index + 1}.  ${item?.label || item?.name}`}
                      </Col>
                      <Col
                        lg={4}
                        md={10}
                        sm={24}
                        xs={24}
                        style={{
                          textAlign: 'center',
                        }}
                      >
                        <ButtonGroup>
                          <IconButton
                            appearance="ghost"
                            size="sm"
                            icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                            onClick={(e) => onPreview(item)}
                            disabled={!item?.path}
                          />
                          <IconButton
                            appearance="ghost"
                            size="sm"
                            icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                            onClick={(e) => onDownload(item)}
                            disabled={!item?.path}
                          />
                          <IconButton
                            appearance="ghost"
                            size="sm"
                            className="rs-btn-ghost-cancel"
                            icon={<Icon icon="trash" className="bt-gost-icon-radius-cancel" />}
                            onClick={(e) => onDelete(item)}
                            disabled={!item?.path}
                          />
                        </ButtonGroup>
                      </Col>
                    </Row>
                  </>
                )
              })}
          </>
        ) : (
          <>
            <p>{formSchema.attachments.label}</p>
            {attachmentsList.length > 0 &&
              attachmentsList.map((item, index) => {
                return (
                  <>
                    <Row
                      style={{
                        borderStyle: 'none none groove none',
                        marginTop: 10,
                        borderColor: '#53535321',
                      }}
                      key={index}
                    >
                      <Col lg={20} md={14} sm={24} xs={24} style={{ padding: 10 }}>
                        {`${index + 1}.  ${item?.label || item?.name}`}
                      </Col>
                      <Col
                        lg={4}
                        md={10}
                        sm={24}
                        xs={24}
                        style={{
                          textAlign: 'center',
                        }}
                      >
                        <ButtonGroup>
                          <IconButton
                            appearance="ghost"
                            size="sm"
                            icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                            onClick={(e) => onPreview(item)}
                            disabled={!item?.path}
                          />
                          <IconButton
                            appearance="ghost"
                            size="sm"
                            icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                            onClick={(e) => onDownload(item)}
                            disabled={!item?.path}
                          />
                          {/* {deleteable && (
                              <IconButton
                                appearance="ghost"
                                size="sm"
                                className="rs-btn-ghost-cancel"
                                icon={<Icon icon="trash" className="bt-gost-icon-radius-cancel" />}
                                onClick={(e) => onDelete(item)}
                                disabled={!item?.path}
                              />
                            )} */}
                        </ButtonGroup>
                      </Col>
                    </Row>
                  </>
                )
              })}
          </>
        )}
      </Row>

      {isError && <Message showIcon type="error" description={isError} />}

      <hr />

      {!disabledForm ? (
        <Button appearance="primary" onClick={handleSubmit(onSubmit)} disabled={isLoading}>
          {formSchema.buttonText}
        </Button>
      ) : (
        <>
          {formSchema.approveButton && (
            <Button
              appearance="primary"
              onClick={() => handleOnApprove(3, formSchema.approveButton)}
              disabled={isLoading}
              style={{ marginRight: 10 }}
            >
              {formSchema.approveButton}
            </Button>
          )}

          {formSchema.approveButton2 && (
            <Button
              appearance="primary"
              onClick={() => handleOnApprove(2, formSchema.approveButton2)}
              disabled={isLoading}
              className={'bt-gost-icon-radius-edit'}
            >
              {formSchema.approveButton2}
            </Button>
          )}
        </>
      )}

      <ConfirmWidget
        title={`ยืนยันการ${formSchema.buttonText}`}
        // confirmBtn={`ยืนยัน${formSchema.buttonText}`}
        // cancleBtn={`ยกเลิก${formSchema.buttonText}`}
        show={isShowConfirm}
        detail={`กรุณายืนยันการ${formSchema.buttonText}`}
        onCancle={onCancle}
        onConfirm={onConfirm}
      />

      <ConfirmWidget
        title={`ยืนยันการ${approveRequest?.buttonText}`}
        show={isShowConfirmApprove}
        detail={`กรุณายืนยันการ${approveRequest?.buttonText}`}
        onCancle={() => {
          setIsShowConfirmApprove(false)
          setApproveRequest()
        }}
        onConfirm={handleCallServiceApprove}
      />
    </Panel>
  )
}
